export default __webpack_public_path__ + "static/media/academia_2.ce43decc.jpg";